(async () => {
    if (!customElements.get("key-features")) {
        class KeyFeatures extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-swiper-key-features-slider]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4,
                    direction: "horizontal",
                    observer: true, // Ensure correct rendering in dynamic sections
                    breakpoints: {
                        320: {
                            slidesPerView: 1.4,
                            spaceBetween: 15,
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1440: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                    },
                };

                // Load custom options from the dataset
                this.loadCustomOptions();

                // Initialize Swiper
                this.init();

                // Register Shopify section events
                this.registerShopifyEvents();
            }

            loadCustomOptions() {
                if (this.dataset.options) {
                    try {
                        const jsonOptions = JSON.parse(this.dataset.options);
                        this.swiperOptions = { ...this.swiperOptions, ...jsonOptions };
                    } catch (error) {
                        console.error("Invalid JSON in data-options:", error);
                    }
                }
            }

            registerShopifyEvents() {
                if (Shopify.designMode) {
                    window.addEventListener("shopify:section:load", () => {
                        this.swiperInstance?.update(); // Update Swiper on section load
                    });
                }
            }

            init() {
                if (this.swiperElement) {
                    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
                } else {
                    console.error("Swiper element not found");
                }
            }
        }

        customElements.define("key-features", KeyFeatures);
    }
})();
